import React from "react";
import { Motion, spring } from "react-motion";
import { Link, NavLink } from "react-router-dom";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";
import "./menuresponsive.component.css";

// LOGOS
import Logo_Color from "../../images/logo-prove-min.svg";

// COMPONENTS
import Social from "../../components/social/social.component";

export default class MenuResponsive extends React.Component {
  state = {
    setLink: false,
  };

  goto() {
    localStorage.setItem("selectedCategory", 0);
    localStorage.setItem("selectedMember", JSON.stringify([true]));
    localStorage.setItem("selectedCountry", JSON.stringify([true]));
    localStorage.setItem("selectedQualification", JSON.stringify([true]));
    localStorage.setItem("selectedArea", JSON.stringify([true]));
    localStorage.setItem("page", 1);
    localStorage.setItem("order", 0);
    localStorage.setItem("isFilter", false);
    localStorage.setItem("neworder", 3);

    setTimeout(() => {
      document
        .querySelector("#start")
        .scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);

    this.setState({
      setLink: false,
    });
  }

  setActive = () => {
    this.setState({
      setLink: true,
    });
  };

  render() {
    let { t, i18n, close, isOpen } = this.props;

    const lang = i18n.language;

    return (
      <Motion
        style={{ x: spring(isOpen ? 250 : 0), y: spring(isOpen ? 100 : 0) }}
      >
        {({ y, x }) => (
          <div
            className="overlay"
            onClick={close}
            style={{
              WebkitTransform: `translate3d(${y}%, 0, 0)`,
              transform: `translate3d(${y}%, 0, 0)`,
            }}
          >
            <div
              className="menu"
              style={{
                WebkitTransform: `translate3d(${x}px, 0, 0)`,
                transform: `translate3d(${x}px, 0, 0)`,
              }}
            >
              <Link to="/" onClick={this.setActive}>
                <Logo>
                  <img src={Logo_Color} alt="logo" />
                </Logo>
              </Link>
              <RespLinks>
                <ul>
                  <li>
                    <NavLink
                      exact
                      to={"/" + lang}
                      activeClassName="activeMenu"
                      className={this.state.setLink ? "activeMenu" : ""}
                      onClick={() => this.goto()}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/" + lang + "/" + t("rede")}
                      activeClassName="activeMenu"
                      onClick={() => this.goto()}
                    >
                      {t("HeaderRede")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/" + lang + "/" + t("restaurantes")}
                      activeClassName="activeMenu"
                      onClick={() => this.goto()}
                    >
                      {t("HeaderRestaurantes")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/" + lang + "/" + t("produtos")}
                      activeClassName="activeMenu"
                      onClick={() => this.goto()}
                    >
                      {t("HeaderProdutos")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/" + lang + "/" + t("receitas")}
                      activeClassName="activeMenu"
                      onClick={() => this.goto()}
                    >
                      {t("HeaderReceitas")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/" + lang + "/" + t("workshops")}
                      activeClassName="activeMenu"
                      onClick={() => this.goto()}
                    >
                      {t("HeaderWorkshops")}
                    </NavLink>
                  </li>
                  <li>
                    <a
                      href="https://backoffice.tasteportugal.com/backend/site/login"
                      rel="noopener noreferrer"
                      target="_blank"
                      className="login"
                    >
                      {t("login")}
                    </a>
                  </li>
                </ul>
              </RespLinks>
              <SocialContent>
                <Social top={false} />
              </SocialContent>
            </div>
          </div>
        )}
      </Motion>
    );
  }
}

const Logo = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 15px;

  img {
    width: 120px;
  }
`;

const RespLinks = styled.div`
  ul {
    list-style: none;
    padding: 0;
    text-align: center;

    li {
      padding-top: 15px;
      padding-bottom: 15px;

      a {
        color: ${Colors.text.secondary};
        font-size: 15px;
        &.login {
          background-color: #11837b;
          color: #ffffff !important;
          border-radius: 3px;
          padding: 10px 15px;
          cursor: pointer;
          text-decoration: none;
          -webkit-transition: all 0.3s ease;
          transition: all 0.3s ease;
          font-family: "PT Sans";
          margin: 0 15px;

          &:hover {
            background: #149a90;
            color: #fff;
          }
        }
      }
    }
  }
`;

const SocialContent = styled.div`
  padding-top: 50px;
`;



// WEBPACK FOOTER //
// ./src/components/menuresponsive/menuresponsive.component.js